// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__12Cq-","top":"style_top__2ICDW","title":"style_title__qX6U5","text":"style_text__3C3sM"};